import type { ErrorCopyFor } from "@amtana/browser";
import type { EXPORT_ERROR_CODES } from "@amtana/export-contract";
import { phrase } from "@amtana/i18n/catalog";
import type { Catalogs, Translation } from "@amtana/i18n/catalog";

// What a user reads when an export fails (packages/module ADR-001).

const EN = {
  notFoundTitle: "This export doesn't exist",
  notFoundDescription: "It may have been deleted. Open your exports to pick another.",
  notReadyTitle: "Your export is still being prepared",
  notReadyDescription: "Wait a moment and try again.",
} as const;

const ES: Translation<typeof EN> = {
  notFoundTitle: "Esta exportación no existe",
  notFoundDescription: "Puede que se haya eliminado. Abre tus exportaciones para elegir otra.",
  notReadyTitle: "Tu exportación todavía se está preparando",
  notReadyDescription: "Espera un momento e inténtalo de nuevo.",
};

export const EXPORT_ERROR_CATALOGS: Catalogs<typeof EN> = { en: EN, es: ES };

export const EXPORT_ERROR_COPY = {
  export_not_found: {
    title: phrase(EXPORT_ERROR_CATALOGS, "notFoundTitle"),
    description: phrase(EXPORT_ERROR_CATALOGS, "notFoundDescription"),
  },
  export_not_ready: {
    title: phrase(EXPORT_ERROR_CATALOGS, "notReadyTitle"),
    description: phrase(EXPORT_ERROR_CATALOGS, "notReadyDescription"),
  },
} satisfies ErrorCopyFor<typeof EXPORT_ERROR_CODES>;
